module.exports = __webpack_public_path__ + "img/head_bg-app-2.98521a89.png";